export const BEST_DESCRIBES_YOU = {
  INVESTOR: 'INVESTOR',
  PROPERTY_MANAGER: 'PROPERTY_MANAGER',
  MIX_OF_BOTH: 'MIX_OF_BOTH',
  ACCOUNTANT: 'ACCOUNTANT',
};
